export default __webpack_public_path__ + "static/media/e4.3f5ed29f.jpg";